// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyBAjnWTRiPH0oSmUrdlNxAaQ3_qukfIPjY",
    authDomain: "ubutouch.firebaseapp.com",
    databaseURL: "https://ubutouch.firebaseio.com",
    projectId: "ubutouch",
    storageBucket: "ubutouch.appspot.com",
    messagingSenderId: "681504730127",
    appId: "1:681504730127:web:f347ff55f11aeb0b66077a"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
